import React, { useState } from "react";
import { FiImage } from "react-icons/fi";

/**
 * Renders an <img>, but if the file doesn't exist yet (or fails to
 * load) shows a styled placeholder instead of a broken-image icon.
 * Drop the real file at the given `src` path and it'll swap in
 * automatically — no code change needed.
 */
const ImageWithFallback = ({ src, alt = "", className = "", placeholderLabel }) => {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div className={`flex flex-col items-center justify-center gap-2 border border-dashed border-line bg-cloud text-muted ${className}`}>
        <FiImage size={28} />
        {placeholderLabel && <span className="px-4 text-center text-xs">{placeholderLabel}</span>}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
    />
  );
};

export default ImageWithFallback;
